import Vue from 'vue';
import Router from 'vue-router';
import Store from '@/store';
import login from './modules/login';
import register from './modules/register';
import getBackPassword from './modules/getBackPassword';
import home from './modules/home';
import mine from './modules/mine';
import videoDetail from './modules/videoDetail';
import longVideoSearch from './modules/longVideoSearch';
import hot from './modules/hot';
import userDetail from './modules/userDetail';
import customerService from './modules/customerService';
import policyProtocol from './modules/policyProtocol';
import download from './modules/download';
// import novel from './modules/novel';
import message from './modules/message';
import publish from './modules/publish';
import community from './modules/community';
import publicPage from './modules/public';
import apps from './modules/apps';
import blackMaterial from './modules/blackMaterial';
import ai from './modules/ai';

import { i18n } from '@/lang';
import { Toast } from 'mand-mobile';

const locale = i18n.locale;
const messages = i18n.messages;
const lang = messages[locale];

Vue.use(Router);

const routes = [
  // {
  //   path: '*', // 匹配所有路径
  //   redirect: { name: 'Home' }
  // },
  {
    path: '/',
    redirect: { name: 'Home' }
  },
  {
    path: '/index',
    name: 'Index',
    component: () => import(/* webpackChunkName: index */ '@views/index'),
    children: [
      ...home(),
      ...mine(),
      ...videoDetail(),
      ...longVideoSearch(),
      ...hot(),
      ...userDetail(),
      ...customerService(),
      ...login(),
      ...register(),
      ...getBackPassword(),
      ...policyProtocol(),
      ...download(),
      // ...novel(),
      ...message(),
      ...publish(),
      ...community(),
      ...publicPage(),
      ...apps(),
      ...blackMaterial(),
      ...ai()
    ]
  }
];

const router = new Router({
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
  routes
});

router.beforeEach((to, from, next) => {
  // if (to.name === from.name) { // 如果是自己跳自己  则不作操作
  //   return;
  // }
  Store.commit('publicStore/setLoadingShowFlag', true);
  const userInfo = localStorage.getItem('userInfo');
  const token = userInfo && JSON.parse(userInfo).token;

  // 未登录的时候跳转到登录页面
  if (to.meta.needLogin && !token) {
    Toast.failed(lang.pleaseLogin);
    next({ path: '/login?redirect=' + from.fullPath });
  } else {
    next();
  }
});

router.afterEach((to, from) => {
  setTimeout(() => {
    Store.commit('publicStore/setLoadingShowFlag', false);
  }, 500);
});

export default router;
